'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var formLabels = (0, _reactIntl.defineMessages)({
    dateOfBirth: {
        'id': 'formLabels.dateOfBirth',
        'defaultMessage': 'Date of Birth'
    },
    gender: {
        'id': 'formLabels.gender',
        'defaultMessage': 'Gender'
    },
    commonName: {
        'id': 'formLabels.commonName',
        'defaultMessage': 'Common Name'
    },
    firstName: {
        'id': 'formLabels.firstName',
        'defaultMessage': 'First Name'
    },
    middleName: {
        'id': 'formLabels.middleName',
        'defaultMessage': 'Middle Name'
    },
    lastName: {
        'id': 'formLabels.lastName',
        'defaultMessage': 'Last Name'
    },
    nationality: {
        'id': 'formLabels.nationality',
        'defaultMessage': 'Nationality'
    },
    placeOfBirth: {
        'id': 'formLabels.placeOfBirth',
        'defaultMessage': 'Place of Birth'
    },
    passportNumber: {
        'id': 'formLabels.passportNumber',
        'defaultMessage': 'Passport #'
    },
    issueDate: {
        'id': 'formLabels.issueDate',
        'defaultMessage': 'Issue Date'
    },
    placeOfIssue: {
        'id': 'formLabels.placeOfIssue',
        'defaultMessage': 'Place of Issue'
    },
    expiryDate: {
        'id': 'formLabels.expirationDate',
        'defaultMessage': 'Expiration Date'
    },
    other: {
        'id': 'formLabels.other',
        'defaultMessage': 'Bus, Train, Boat, other, or already / remaining in destination.'
    },
    flight: {
        'id': 'formLabels.flight',
        'defaultMessage': 'Flight'
    },
    connectingFlight: {
        'id': 'formLabels.connectingFlight',
        'defaultMessage': 'Connecting Flight'
    },
    departureDate: {
        'id': 'formLabels.departureDate',
        'defaultMessage': 'Flight Date'
    },
    departureAirport: {
        'id': 'formLabels.departureAirport',
        'defaultMessage': 'From Airport'
    },
    connectingAirport: {
        'id': 'formLabels.connectingAirport',
        'defaultMessage': 'Connecting Airport'
    },
    startDate: {
        'id': 'formLabels.startDate',
        'defaultMessage': 'Start Date'
    },
    finishDate: {
        'id': 'formLabels.finishDate',
        'defaultMessage': 'End Date'
    },
    policyType: {
        'id': 'formLabels.policyType',
        'defaultMessage': 'Policy Type'
    },
    policyNumber: {
        'id': 'formLabels.policyNumber',
        'defaultMessage': 'Policy Number'
    },
    policyEmergencyPhoneNumber: {
        'id': 'formLabels.policyEmergencyPhoneNumber',
        'defaultMessage': 'Policy Emergency Phone Number'
    },
    policyProvider: {
        'id': 'formLabels.policyProvider',
        'defaultMessage': 'Policy Provider'
    },
    waiverCertifyGuardian: {
        'id': 'formLabels.waiverCertifyGuardian',
        'defaultMessage': 'I certify that I am the parent/guardian.'
    },
    waiverAcknowledgementMinor: {
        'id': 'formLabels.waiverAcknowledgementMinor',
        'defaultMessage': 'I, the guardian/parent of {paxName}, have read and hereby agree with\n                         the above waiver on behalf of the minor on {date}.'
    },
    waiverGuardianFirstName: {
        'id': 'formLabels.waiverGuardianFirstName',
        'defaultMessage': 'Guardian/Parent\'s First Name'
    },
    waiverGuardianLastName: {
        'id': 'formLabels.waiverGuardianLastName',
        'defaultMessage': 'Guardian/Parent\'s Last Name'
    },
    waiverGuardianEmail: {
        'id': 'formLabels.waiverGuardianEmail',
        'defaultMessage': 'Guardian/Parent\'s Email'
    },
    waiverAcknowledgement: {
        'id': 'formLabels.waiverAcknowledgement',
        'defaultMessage': 'I, {paxName}, have read and hereby agree with the above on {date}.'
    },
    stubCompletionPrompt: {
        'id': 'formLabels.stubCompletionPrompt',
        'defaultMessage': 'This requirement cannot be fulfilled online.\n                         Please {contactPrompt} to complete it.'
    },
    stubCompletionPromptWithEmail: {
        'id': 'formLabels.stubCompletionPromptWithEmail',
        'defaultMessage': 'This requirement cannot be fulfilled online.\n                         Please email {contactPromptWithEmail} with your scan attached to complete the requirement.\n                         Once received this will be completed. Please allow 5-7 business days from date of submission.'
    },
    stubCompletionMedicalPrompt: {
        'id': 'formLabels.stubCompletionMedicalPrompt',
        'defaultMessage': 'Due to the remote location and limited medical access of Expedition\n                         tours, please consult with your doctor to complete the medical\n                         form available {link}.'
    },
    stubCompletionLiabilityWaiverPrompt: {
        'id': 'formLabels.stubCompletionLiabilityWaiverPrompt',
        'defaultMessage': 'We require a special Acknowledgement and Assumption of Risk waiver to\n                         be signed. Please download {thisDocument}, sign, and email to {email}.'
    },
    stubCompletionLiabilityWaiverKayakingPrompt: {
        'id': 'formLabels.stubCompletionLiabilityWaiverKayakingPrompt',
        'defaultMessage': 'We require a special Kayaking Acknowledgement and Assumption of Risk waiver to\n                         be signed. Please download {thisDocument}, sign, and email to {email}.'
    },
    stubComplete: {
        'id': 'formLabels.stubComplete',
        'defaultMessage': 'This requirement is complete, thank you.'
    }
}); /**
    *  formLabels is in MessageDescriptorMap format for react-intl:
    *
    *    type MessageDescriptor = {
    *        id: string,
    *        defaultMessage: string,
    *        description?: string,
    *    };
    *
    *    type MessageDescriptorMap = {[key: string]: MessageDescriptor};)
    */

exports.default = formLabels;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formLabels.js
// module id = 1363
// module chunks = 0